/**
 * Created by rathompson on 8/2/23
 * File: IpInheritedRenderer.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { VFC } from 'react'
import type { Row } from 'react-table'
import type { TrustedIpTableRow } from '../TrustedIpTable'
import { useContext } from 'react'
import GlobalContext from '../../../../common/context/GlobalContext'
import { Body } from '@panwds/react-ui'

const IpInheritedRenderer: VFC<{
  row: Row<TrustedIpTableRow>,
  value: string
}> = ({ value }) => {

  const { treeReducer } = useContext(GlobalContext)
  const { selectedTreeNode } = treeReducer

  return (!value || value === selectedTreeNode?.id) ? (<></>) : <Body addClassName='cm-truncate'>{value}</Body>
}

export default IpInheritedRenderer
